import styled from 'styled-components';

export const App = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
